module.exports = require("././angular-cookies.js");


//////////////////
// WEBPACK FOOTER
// angular-cookies (bower component)
// module id = 381
// module chunks = 1